<his-plam [label]="setting.label | hisUi"
          [helptext]="setting.helptext | hisUi" [required]="setting.required"
          [title]="title">
    <p-autoComplete #content [(ngModel)]="selectedItem" [suggestions]="filteredItems" [forceSelection]="true"
                    (completeMethod)="filterItems($event)" optionLabel="label" [dropdown]="true"
                    optionValue="key"
                    [readonly]="setting.readonly">
    </p-autoComplete>
</his-plam>
